import { Formik } from "formik";
import { Button, CardBody, Col, Form, FormGroup, Input, Row } from "reactstrap";
import * as Yup from 'yup';
import SelectField from "../Utils/SelectField";
import InputField from "../Utils/InputField";
import { addQuota } from "../../slices/QuotaManagement/AddQuota/thunk";
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { editQuota } from "../../slices/QuotaManagement/UpdateQuota/thunk";
import { LabelText } from "../Utils/Input";
import CommonButton from "../Utils/CommonButton";

export const QuotaForm = ({ extractedData, toggleModals, setModalOpen, initialData, isEditMode }) => {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [enableTTC, setEnableTTC] = useState(false)

    const options1 = [...new Set(extractedData.map(({ eventType }) => eventType))].map(eventType => ({
        label: eventType,
        value: eventType
    }));

    const uomMap = extractedData.reduce((acc, { eventType, uom }) => {
        if (!acc[eventType]) acc[eventType] = [];
        acc[eventType].push({ label: uom, value: uom });
        return acc;
    }, {});

    useEffect(() => {
        if(isEditMode){
            setEnableTTC(initialData.TTC)
        }
    },[])

    let initialValues = {
        usageeventtype: isEditMode && initialData.usageEventType ?
            { label: initialData.usageEventType, value: initialData.usageEventType } : null,
        uom: isEditMode && initialData.UOM ?
            { label: initialData.UOM, value: initialData.UOM } : null,
        initialQuota: isEditMode ? initialData.initialQuota : "",
        incrementalQuota: isEditMode ? initialData.incrementalQuota : "",
        initialValidityTime: isEditMode ? initialData.initialValidityTime : "",
        incrementalValidityTime: isEditMode ? initialData.incrementalValidityTime : "",
        TTC: isEditMode ? initialData?.TTC : false
    };

    const validationSchema = Yup.object().shape({
        usageeventtype: Yup.object().required("Select an event usage"),
        uom: Yup.object().required("Select an UOM"),
        initialQuota: Yup.string().required("Enter Initial Quota"),
        incrementalQuota: Yup.string().required("Enter Incremental Quota"),
        initialValidityTime: Yup.string().required("Enter Initial Validity"),
        incrementalValidityTime: Yup.string().required("Enter Incremental Validity"),
    });

    return (
        <div>
            <Formik
                validationSchema={validationSchema}
                initialValues={initialValues}
                onSubmit={async (values) => {
                    const payload = {
                        usageEventType: values.usageeventtype?.value || "",
                        uom: values.uom?.value || "",
                        initialQuota: parseInt(values.initialQuota, 10) || 0,
                        incrementalQuota: parseInt(values.incrementalQuota, 10) || 0,
                        initialValidityTime: parseInt(values.initialValidityTime, 10) || 0,
                        incrementalValidityTime: parseInt(values.incrementalValidityTime, 10) || 0,
                        TTC: enableTTC
                    };
                    if (!isEditMode) {
                        dispatch(addQuota(payload, setLoading, setModalOpen));
                    } else {
                        dispatch(editQuota(payload, initialData.usageEventType, setLoading, setModalOpen));
                    }
                }}
            >
                {({
                    handleChange,
                    handleSubmit,
                    handleBlur,
                    errors,
                    touched,
                    values,
                    setFieldValue,
                }) => (
                    <Form className="needs-validation" onSubmit={handleSubmit}>
                        <Col lg={12} className="mt-n2">
                            <Row className="gy-4 px-3 ">
                                <CardBody>
                                    <Row>
                                        <Col xxl={6} md={6} className="pe-0">
                                            <div>
                                                <FormGroup>
                                                    <LabelText
                                                        htmlFor={"usageeventtype"}
                                                        classLabelName={"ms-0 rv-form-label"}
                                                        className={"text-danger"}
                                                        displayText={"Usage Event Type"}
                                                        important={"*"}
                                                    />
                                                    <LabelText
                                                        htmlFor={"usageeventtype"}
                                                        classLabelName={`d-block ms-0 rv-sub-label ${touched.usageeventtype && errors.usageeventtype
                                                                ? "rv-label-danger"
                                                                : "rv-label-muted"
                                                            }`}
                                                        displayText={
                                                            touched.usageeventtype && errors.usageeventtype
                                                                ? errors.usageeventtype
                                                                : "Select an event usage"
                                                        }
                                                    />
                                                    <SelectField
                                                        placeholder=""
                                                        options={options1}
                                                        data-testid="select-usageeventtype"
                                                        value={values.usageeventtype || null}
                                                        className={`${touched.usageeventtype && !values.usageeventtype ? "error-input" : ""}`}
                                                        handleChange={(e) => {
                                                            setFieldValue("usageeventtype", e);
                                                            const uoms = uomMap[e?.value] || [];
                                                            setFieldValue("uom", uoms.length > 0 ? uoms[0] : null);
                                                        }}
                                                        isDisabled={isEditMode ? true : false}
                                                        isRVStyle={true}
                                                    />
                                                </FormGroup>
                                            </div>
                                        </Col>

                                        <Col xxl={6} md={6} className="pe-0">
                                            <div>
                                                <FormGroup>
                                                    <LabelText
                                                        htmlFor={"uom"}
                                                        classLabelName={"ms-0 rv-form-label"}
                                                        className={"text-danger"}
                                                        displayText={"UoM"}
                                                        important={"*"}
                                                    />
                                                    <LabelText
                                                        htmlFor={"uom"}
                                                        classLabelName={`d-block ms-0 rv-sub-label ${touched.uom && errors.uom
                                                                ? "rv-label-danger"
                                                                : "rv-label-muted"
                                                            }`}
                                                        displayText={
                                                            touched.uom && errors.uom
                                                                ? errors.uom
                                                                : "Select an UOM"
                                                        }
                                                    />
                                                    <SelectField
                                                        placeholder=""
                                                        options={uomMap[values.usageeventtype?.value] || []}
                                                        data-testid="select-uom"
                                                        value={values.uom || null}
                                                        className={`${touched.uom && !values.uom ? "error-input" : ""}`}
                                                        handleChange={(e) => setFieldValue("uom", e)}
                                                        isDisabled={isEditMode ? true : false}
                                                        isRVStyle={true}
                                                    />
                                                </FormGroup>
                                            </div>
                                        </Col>

                                        <Col xxl={6} md={6} className="pe-0">
                                            <div>
                                                <FormGroup>
                                                    <LabelText
                                                        htmlFor={"initialQuota"}
                                                        classLabelName={"ms-0 rv-form-label"}
                                                        className={"text-danger"}
                                                        displayText={"Initial Quota"}
                                                        important={"*"}
                                                    />
                                                    <LabelText
                                                        htmlFor={"initialQuota"}
                                                        classLabelName={`d-block ms-0 rv-sub-label ${touched.initialQuota && errors.initialQuota
                                                                ? "rv-label-danger"
                                                                : "rv-label-muted"
                                                            }`}
                                                        displayText={
                                                            touched.initialQuota && errors.initialQuota
                                                                ? errors.initialQuota
                                                                : "Enter Initial Quota"
                                                        }
                                                    />
                                                    <InputField
                                                        name={"initialQuota"}
                                                        type={"text"}
                                                        className={"form-control"}
                                                        id={"initialQuota"}
                                                        handleChange={handleChange}
                                                        handleBlur={handleBlur}
                                                        value={values.initialQuota || ''}
                                                        invalid={touched.initialQuota && errors.initialQuota ? true : false}
                                                    />
                                                </FormGroup>
                                            </div>
                                        </Col>

                                        <Col xxl={6} md={6} className="pe-0">
                                            <div>
                                                <FormGroup>
                                                    <LabelText
                                                        htmlFor={"incrementalQuota"}
                                                        classLabelName={"ms-0 rv-form-label"}
                                                        className={"text-danger"}
                                                        displayText={"Incremental Quota"}
                                                        important={"*"}
                                                    />
                                                    <LabelText
                                                        htmlFor={"incrementalQuota"}
                                                        classLabelName={`d-block ms-0 rv-sub-label ${touched.incrementalQuota && errors.incrementalQuota
                                                                ? "rv-label-danger"
                                                                : "rv-label-muted"
                                                            }`}
                                                        displayText={
                                                            touched.incrementalQuota && errors.incrementalQuota
                                                                ? errors.incrementalQuota
                                                                : "Enter Incremental Quota"
                                                        }
                                                    />
                                                    <InputField
                                                        name={"incrementalQuota"}
                                                        type={"text"}
                                                        className={"form-control"}
                                                        id={"incrementalQuota"}
                                                        handleChange={handleChange}
                                                        handleBlur={handleBlur}
                                                        value={values.incrementalQuota || ''}
                                                        invalid={touched.incrementalQuota && errors.incrementalQuota ? true : false}
                                                    />
                                                </FormGroup>
                                            </div>
                                        </Col>

                                        {/* <Col xxl={6} md={6} className="pe-0">
                                            <div>
                                                <FormGroup>
                                                    <LabelText
                                                        htmlFor={"validity"}
                                                        classLabelName={"ms-0 rv-form-label"}
                                                        className={"text-danger"}
                                                        displayText={"Validity"}
                                                        important={"*"}
                                                    />
                                                    <LabelText
                                                        htmlFor={"validity"}
                                                        classLabelName={`d-block ms-0 rv-sub-label ${touched.validity && errors.validity
                                                                ? "rv-label-danger"
                                                                : "rv-label-muted"
                                                            }`}
                                                        displayText={
                                                            touched.validity && errors.validity
                                                                ? errors.validity
                                                                : "Enter the Validity"
                                                        }
                                                    />
                                                    <InputField
                                                        name={"validity"}
                                                        type={"text"}
                                                        className={"form-control"}
                                                        id={"validity"}
                                                        handleChange={handleChange}
                                                        handleBlur={handleBlur}
                                                        value={values.validity || ''}
                                                        invalid={touched.validity && errors.validity ? true : false}
                                                    />
                                                </FormGroup>
                                            </div>
                                        </Col> */}
                                        <Col xxl={6} md={6} className="pe-0">
                                            <div>
                                                <FormGroup>
                                                    <LabelText
                                                        htmlFor={"initialValidityTime"}
                                                        classLabelName={"ms-0 rv-form-label"}
                                                        className={"text-danger"}
                                                        displayText={"Initial Validity"}
                                                        important={"*"}
                                                    />
                                                    <LabelText
                                                        htmlFor={"initialValidityTime"}
                                                        classLabelName={`d-block ms-0 rv-sub-label ${touched.initialValidityTime && errors.initialValidityTime
                                                            ? "rv-label-danger"
                                                            : "rv-label-muted"
                                                            }`}
                                                        displayText={
                                                            touched.initialValidityTime && errors.initialValidityTime
                                                                ? errors.initialValidityTime
                                                                : "Enter the Initial Validity"
                                                        }
                                                    />
                                                    <InputField
                                                        name={"initialValidityTime"}
                                                        type={"text"}
                                                        className={"form-control"}
                                                        id={"initialValidityTime"}
                                                        handleChange={handleChange}
                                                        handleBlur={handleBlur}
                                                        value={values.initialValidityTime || ''}
                                                        invalid={touched.initialValidityTime && errors.initialValidityTime ? true : false}
                                                    />
                                                </FormGroup>
                                            </div>
                                        </Col>
                                        <Col xxl={6} md={6} className="pe-0">
                                            <div>
                                                <FormGroup>
                                                    <LabelText
                                                        htmlFor={"incrementalValidityTime"}
                                                        classLabelName={"ms-0 rv-form-label"}
                                                        className={"text-danger"}
                                                        displayText={"Incremental Validity"}
                                                        important={"*"}
                                                    />
                                                    <LabelText
                                                        htmlFor={"incrementalValidityTime"}
                                                        classLabelName={`d-block ms-0 rv-sub-label ${touched.incrementalValidityTime && errors.incrementalValidityTime
                                                            ? "rv-label-danger"
                                                            : "rv-label-muted"
                                                            }`}
                                                        displayText={
                                                            touched.incrementalValidityTime && errors.incrementalValidityTime
                                                                ? errors.incrementalValidityTime
                                                                : "Enter the Incremental Validity"
                                                        }
                                                    />
                                                    <InputField
                                                        name={"incrementalValidityTime"}
                                                        type={"text"}
                                                        className={"form-control"}
                                                        id={"incrementalValidityTime"}
                                                        handleChange={handleChange}
                                                        handleBlur={handleBlur}
                                                        value={values.incrementalValidityTime || ''}
                                                        invalid={touched.incrementalValidityTime && errors.incrementalValidityTime ? true : false}
                                                    />
                                                </FormGroup>
                                            </div>
                                        </Col>
                                        <Col xxl={12} md={12} className="pe-0">
                                            <div>
                                                <FormGroup switch className="ps-0">
                                                    <LabelText
                                                        htmlFor={"TTC"}
                                                        classLabelName={"ms-0 rv-form-label"}
                                                        className={"text-danger ps-0"}
                                                        displayText={"Tariff Time Change"}
                                                        important={"*"}
                                                    />
                                                    <LabelText
                                                        htmlFor={"TTC"}
                                                        classLabelName={`d-block ms-0 rv-sub-label ${touched.TTC && errors.TTC
                                                            ? "rv-label-danger"
                                                            : "rv-label-muted"
                                                            }`}
                                                        displayText={
                                                            touched.TTC && errors.TTC
                                                                ? errors.TTC
                                                                : "Enable/Disable Tariff Time Change"
                                                        }
                                                    />
                                                    <Input
                                                        type={"switch"}
                                                        className="rv-form-switch-input ms-0"
                                                        checked={enableTTC}
                                                        onClick={() => setEnableTTC(!enableTTC)}
                                                        name={"TTC"}
                                                    />
                                                </FormGroup>
                                            </div>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Row>
                        </Col>

                        <Row className="justify-content-end mb-2 mt-2">
                            <div className="live-preview">
                                <div className="d-flex justify-content-center gap-2 mt-2">
                                    <CommonButton
                                        outline={true}
                                        className={
                                            "btn-label rv-secondary-btn rounded-1 px-1 ps-3 py-1  w-md-auto text-nowrap"
                                        }
                                        color={"main-color"}
                                        type={"button"}  
                                        buttonAction={toggleModals}  
                                        buttonText={"Close"}
                                        icon={
                                            <i className="ri-close-fill label-icon align-middle fs-16 me-1" style={{ transform: "scaleX(-1)", borderLeft: "1px solid" }}>
                                            </i>
                                        }
                                        btnTxtClsName={"px-2 ps-3 ms-2 me-1"}
                                    />

                                    <CommonButton
                                        color={"secondary"}
                                        type="submit"
                                        buttonText={"Submit"}
                                        icon={<i className="ri-checkbox-circle-line label-icon align-middle fs-16 me-1"></i>}
                                        className="btn-label rv-primary-btn rounded-1 px-1 ps-4 py-1  w-md-auto text-nowrap"
                                        btnTxtClsName={"px-2 ps-3 ms-2 me-1"}
                                    />
                                </div>
                                {/* <div className="d-flex justify-content-center gap-2">
                                    <Button outline type="reset" onClick={toggleModals}>Close</Button>
                                    <Button type="submit">Submit</Button>
                                </div> */}
                            </div>
                        </Row>
                    </Form>
                )}
            </Formik>
        </div>
    );
};